import React, { useState, useEffect } from "react";
import {
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  Icon,
} from "@material-ui/core";
import "../../styles/whychoose.scss";
import config from "../config/config";
// import VerifiedIcon from "@mui/icons-material/Verified";

function WhyBbys(props) {
  const [resources, setResources] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [usingFallback, setUsingFallback] = useState(false);
  const isTLS = window.location.pathname.includes("/tls") || window.location.pathname.includes("/averra");

  const primColor = props?.partner?.primary_color || "#B5D4FF";
  const secColor = props?.partner?.secondary_color || "#B5D4FF";
  const checkIcon = "/assets/images/right_icon.png";

  const features = [
    "Buy and move before you sell",
    "Choose your real estate agent",
    "List and sell for full price",
    "Eliminate home sale contingencies",
    "Submit competitive offers that are more likely to win",
    "Stage and show an empty home",
    "Protect your closing with a backup offer",
  ];

  const data = [
    [true, false, false],
    [true, true, true],
    [true, true, false],
    [true, false, true],
    [true, false, true],
    [true, false, false],
    [true, false, false],
  ];

  const secondary = props?.partner?.secondary_color || "#75C043";
  const primary = props?.partner?.primary_color || "#75C043";

  const FALLBACK_RESOURCES = [
    {
      id: 1,
      title: "One Page Overview",
      subtitle:
        "Calque’s one page overview of better buy before you sell solutions.",
      img: "/assets/images/Better buy before you sell solution Built for you.png",
      pdf: "/assets/pdfs/Better buy before you sell solution Built for you.pdf",
    },
    {
      id: 2,
      title: "A Guide to Buy Before You Sell",
      subtitle:
        "Calque’s guide to buy before you sell on how it works and frequently asked questions.",
      img: "/assets/images/A Guide to buy before you sell.png",
      pdf: "/assets/pdfs/A Guide to buy before you sell.pdf",
    },
    {
      id: 3,
      title: "Choose the Right Buy Before You Sell Experience",
      subtitle: "A document comparing different BBYS solutions.",
      img: "/assets/images/Choose the right buy before you sell Experience.png",
      pdf: "/assets/pdfs/Choose the right buy before you sell Experience.pdf",
    },
    {
      id: 4,
      title: "Welcome Flyer",
      subtitle:
        "Overview for loan officers serving as a welcome flyer by Calque.",
      img: "/assets/images/Welcome to calque.png",
      pdf: "/assets/pdfs/Welcome to calque.pdf",
    },
    {
      id: 5,
      title: "Customizable Flyer for Realtors",
      subtitle:
        "Customizable flyer of partnership with Calque to give to realtors.",
      img: "/assets/images/Buy Before you sell.png",
      pdf: "/assets/pdfs/Buy Before you sell.pdf",
    },
    {
      id: 6,
      title: "Overcoming Common Objections",
      subtitle: "Practical scripts to handle client concerns effectively.",
      img: "/assets/images/Overcoming comman objections.png",
      pdf: "/assets/pdfs/Overcoming comman objections.pdf",
    },
  ];
  const NORMALIZED_FALLBACK_RESOURCES = FALLBACK_RESOURCES.map((item) => ({
    resource_id: item.id,
    resource_title: item.title,
    resource_description: item.subtitle,
    card_image_file: item.img,
    resource_file: item.pdf,
  }));

  // useEffect(() => {
  //   const fetchResources = async () => {
  //     try {
  //       setLoading(true);
  //       const authorise = process.env.REACT_APP_API_KEY;

  //       const response = await fetch(`${config.baseUrlCP}get-calque-academy-resources/`, {
  //         method: 'GET',
  //         headers: {
  //           'Accept': 'application/json',
  //           'Authorization': `${authorise}`,
  //           'Content-Type': 'application/json',
  //           'Accept-Encoding': 'gzip, deflate',
  //         },
  //       });

  //       if (!response.ok) {
  //         throw new Error(`HTTP error! status: ${response.status}`);
  //       }

  //       const contentType = response.headers.get("content-type");
  //       if (!contentType || !contentType.includes("application/json")) {
  //         throw new Error("Server did not return JSON");
  //       }

  //       const data = await response.json();
  //       setResources(data);
  //       setError(null);
  //     } catch (err) {
  //       console.error('Error fetching resources:', err);
  //       setError(err.message);

  //       // Fallback to empty array on error so the component still renders
  //       setResources([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchResources();
  // }, []);

  //Always gets the last string of the url
  const pathname = window.location.pathname;
  // console.log(pathname);
  const pathParts = pathname.split("/").filter(Boolean);
  const partnerName = pathParts[pathParts.length - 1];

  useEffect(() => {
    const fetchResources = async () => {
      try {
        setLoading(true);
        setUsingFallback(false);
        setError(null);

        const authorise = process.env.REACT_APP_API_KEY;

        const response = await fetch(
          `${config.baseUrlCP}get-calque-academy-resources/?partner=${partnerName}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: `${authorise}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();

        if (Array.isArray(data) && data.length > 0) {
          setResources(data);
        } else {
          setResources(NORMALIZED_FALLBACK_RESOURCES);
          setUsingFallback(true);
        }
      } catch (err) {
        console.warn("API failed, using fallback resources", err);

        // NO error state – fallback is valid data
        setResources(NORMALIZED_FALLBACK_RESOURCES);
        setUsingFallback(true);
      } finally {
        setLoading(false);
      }
    };

    fetchResources();
  }, []);

  return (
    <div className="bbys-table-main-container inter" id="whyworkwithus">
      <div style={{ textAlign: "center" }}>
        <h2 className="new-heading" style={{ marginBottom: "10px" }}>
          Why <span style={{ color: secColor }}>Buy Before You Sell</span> With
          Us?
        </h2>
      </div>

      {/* TABLE */}
      <div className="bbys-table-scroll">
        <TableContainer
          style={{
            marginTop: "20px",
            borderRadius: "20px",
            overflow: "hidden",
            overflowX: "auto",
            border: "1px solid #E4EEF7",
          }}
        >
          <Table style={{ borderCollapse: "separate", width: "100%" }}>
            <TableHead>
              <TableRow>
                <TableCell
                  style={{ borderBottom: "none", width: "40%" }}
                ></TableCell>

                {/* TRADITIONAL */}
                <TableCell
                  align="center"
                  style={{
                    fontWeight: 700,
                    fontSize: "20px",
                    padding: "18px",
                    borderBottom: "1px solid #E4EEF7",
                    background: "#EAF1FF",
                  }}
                >
                  Traditional Mortgage
                </TableCell>

                {/* iBUYERS */}
                <TableCell
                  align="center"
                  style={{
                    fontWeight: 700,
                    fontSize: "20px",
                    padding: "18px",
                    borderBottom: "1px solid #E4EEF7",
                    background: "#F4F8FF",
                  }}
                >
                  iBuyers
                </TableCell>

                {/* OUR BBYS */}
                <TableCell
                  align="center"
                  style={{
                    fontWeight: 700,
                    fontSize: "20px",
                    padding: "18px",
                    color: "#fff",
                    background: primColor,
                    borderBottom: "1px solid #E4EEF7",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Calque's Buy Before You Sell{" "}
                  <Icon
                    style={{ color: "#ffffffff", fontSize: 18, marginLeft: 3 }}
                  >
                    verified
                  </Icon>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {features.map((text, index) => (
                <TableRow
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#FFFFFF" : "#F8FBFF",
                  }}
                >
                  {/* Feature Name (left column) */}
                  <TableCell
                    style={{
                      fontWeight: 600,
                      fontSize: "18px",
                      padding: "18px",
                      borderBottom: "1px solid #E4EEF7",
                      width: "40%",
                    }}
                  >
                    {text}
                  </TableCell>

                  {/* Traditional */}
                  <TableCell
                    align="center"
                    style={{
                      borderBottom: "1px solid #E4EEF7",
                      padding: "18px",
                    }}
                  >
                    {data[index][1] && (
                      <img src={checkIcon} width={22} alt="check" />
                    )}
                  </TableCell>

                  {/* iBuyers */}
                  <TableCell
                    align="center"
                    style={{
                      borderBottom: "1px solid #E4EEF7",
                      padding: "18px",
                    }}
                  >
                    {data[index][2] && (
                      <img src={checkIcon} width={22} alt="check" />
                    )}
                  </TableCell>

                  {/* BBYS */}
                  <TableCell
                    align="center"
                    style={{
                      borderBottom: "1px solid #E4EEF7",
                      padding: "18px",
                      background: "#F4F8FF",
                    }}
                  >
                    {data[index][0] && (
                      <img src={checkIcon} width={22} alt="check" />
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      {isTLS ? (
        <div className="tls-map-section">
          <div className="tls-map-content">
            <h1>Where Can You <span style={{color:secondary}}>Buy Before You Sell</span> With Calque?</h1>
            <p>
              Explore where BBYS+ and BYOC+ are available so you can choose the
              right solution and keep your clients moving forward with
              confidence.
            </p>
          </div>

          <div className="tls-map-image-wrapper">
            <img src="/assets/images/TlsMap.png" alt="TLS Map" />
          </div>
        </div>
      ) : (
        <></>
      )}

      <div className="resources-wrapper" style={isTLS ? { paddingTop:0 } : {}}>
        <h2 className="resources-title">
          Calque Academy <span style={{ color: secondary }}>Resources</span>
        </h2>

        {loading && (
          <div style={{ textAlign: "center", padding: "40px" }}>
            Loading resources...
          </div>
        )}

        {error && (
          <div
            style={{ textAlign: "center", padding: "40px", color: "#d32f2f" }}
          >
            Error loading resources: {error}
          </div>
        )}

        {!loading && !error && (
          <div className="resources-grid">
            {resources.map((item) => (
              <div className="resource-card" key={item.resource_id}>
                <div className="resource-image">
                  <img src={item.card_image_file} alt={item.resource_title} />
                </div>

                <div className="resource-content">
                  <h3
                    className="resource-heading"
                    style={{ color: primary, fontFamily: "Inter" }}
                  >
                    {item.resource_title}
                  </h3>

                  <p
                    className="resource-subtitle"
                    style={{ fontFamily: "Inter", color: "black" }}
                  >
                    {item.resource_description}
                  </p>

                  <button
                    className="download-btn"
                    style={{
                      backgroundColor: secondary,
                      color: "white",
                      width: "142px",
                      height: "35px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "5px",
                      padding: "10px 20px !important",
                    }}
                    onClick={() => window.open(item.resource_file, "_blank")}
                  >
                    Download PDF
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default WhyBbys;
